import { useState, useEffect } from "react";
import {
  aplicarMascaraCPF,
  formatarNomeUpper,
  aplicarMascaraCEP,
  aplicarMascaraTelefone,
  formatarData
} from "../../utils/formatadores";

const ModalDetalhesCliente = ({
  cliente,
  onClose,
  onAtualizarCliente,
  onAbrirHistoricoCliente,
  onAbrirHistoricoFinanceiro,
  onAbrirProntuarioCliente
}) => {
  const [editando, setEditando] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const [formData, setFormData] = useState({
    nomeCliente: "",
    dataNascimento: "",
    cpf: "",
    telefone: "",
    email: "",
    indicadoPor: "",
    rua: "",
    numero: "",
    bairro: "",
    cidade: "",
    estado: "",
    cep: ""
  });

  useEffect(() => {
    if (cliente) {
      setFormData({
        ...cliente,
        nomeCliente: cliente.nomeCliente || cliente.nome || "",
        dataNascimento: cliente.dataNascimento ? cliente.dataNascimento.split("T")[0] : ""
      });
    }
  }, [cliente]);

  if (!cliente) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let valorFormatado = value;

    if (name === "cep") {
      valorFormatado = aplicarMascaraCEP(value);
    } else if (name === "telefone") {
      valorFormatado = aplicarMascaraTelefone(value);
    } else if (name === "estado") {
      valorFormatado = value.toUpperCase().slice(0, 2);
    } else if (name === "dataNascimento") {
      const partes = value.split("-");
      if (partes[0] && partes[0].length > 4) {
        partes[0] = partes[0].slice(0, 4);
        valorFormatado = partes.join("-");
      }
    }

    setFormData((prev) => ({ ...prev, [name]: valorFormatado }));
  };

  const handleSalvarEdicao = async (e) => {
    e.preventDefault();
    if (!onAtualizarCliente) return;

    setCarregando(true);
    try {
      const resultado = await onAtualizarCliente(formData);
      if (resultado?.success) {
        setEditando(false);
        alert("Cliente atualizado com sucesso!");
      }
    } catch (error) {
      alert("Erro ao atualizar cliente: " + error.message);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content card">
        <div className="modal-header">
          <h2>{editando ? "Editar Cliente" : "Detalhes do Cliente"}</h2>
          <div className="header-actions">
            {!editando && (
              <>
                <button
                  type="button"
                  onClick={() => setEditando(true)}
                  className="btn-save"
                >
                  ✏️ Editar
                </button>
                <button type="button" onClick={onClose} className="btn-cancel">
                  ✕ Fechar
                </button>
              </>
            )}
          </div>
        </div>

        <div className="card modal-body-card">
          {editando ? (
            <form onSubmit={handleSalvarEdicao} className="form-grid">
              <div className="form-group">
                <label>Nome:</label>
                <input
                  type="text"
                  name="nomeCliente"
                  value={formatarNomeUpper(formData.nomeCliente) || ""}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>CPF:</label>
                <input
                  type="text"
                  name="cpf"
                  value={aplicarMascaraCPF(formData.cpf) || ""}
                  disabled
                  className="input-disabled"
                />
              </div>

              <div className="form-group">
                <label>Data de Nascimento:</label>
                <input
                  type="date"
                  name="dataNascimento"
                  value={formData.dataNascimento || ""}
                  max="9999-12-31"
                  min="1900-01-01"
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Telefone:</label>
                <input
                  type="text"
                  name="telefone"
                  maxLength={15}
                  value={aplicarMascaraTelefone(formData.telefone) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>E-mail:</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Indicado por:</label>
                <input
                  type="text"
                  name="indicadoPor"
                  value={formatarNomeUpper(formData.indicadoPor) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group full-width">
                <label>Rua:</label>
                <input
                  type="text"
                  name="rua"
                  value={formatarNomeUpper(formData.rua) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Número:</label>
                <input
                  type="text"
                  name="numero"
                  value={formData.numero || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Bairro:</label>
                <input
                  type="text"
                  name="bairro"
                  value={formatarNomeUpper(formData.bairro) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Cidade:</label>
                <input
                  type="text"
                  name="cidade"
                  value={formatarNomeUpper(formData.cidade) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Estado:</label>
                <input
                  type="text"
                  name="estado"
                  maxLength={2}
                  value={formatarNomeUpper(formData.estado) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>CEP:</label>
                <input
                  type="text"
                  name="cep"
                  maxLength={9}
                  value={aplicarMascaraCEP(formData.cep) || ""}
                  onChange={handleInputChange}
                />
              </div>

              <div className="modal-actions">
                <button type="submit" className="btn-save" disabled={carregando}>
                  {carregando ? <span className="spinner-loader"></span> : "Atualizar"}
                </button>
                <button
                  type="button"
                  onClick={() => setEditando(false)}
                  className="btn-cancel"
                >
                  Cancelar
                </button>
              </div>
            </form>
          ) : (
            <>
              <p>
                <b>Nome:</b>{" "}
                {formatarNomeUpper(cliente.nomeCliente || cliente.nome)}
              </p>
              <p><b>CPF:</b> {aplicarMascaraCPF(cliente.cpf) || "Não informado"}</p>
              <p>
                <b>Data de Nascimento:</b>{" "}
                {cliente.dataNascimento
                  ? formatarData(cliente.dataNascimento)
                  : "Não informada"}
              </p>
              <p><b>Telefone:</b> {aplicarMascaraTelefone(cliente.telefone) || "Não informado"}</p>
              <p><b>E-mail:</b> {cliente.email || "Não informado"}</p>
              <p>
                <b>Endereço:</b>{" "}
                {cliente.rua
                  ? `${formatarNomeUpper(cliente.rua)}, ${cliente.numero || "S/N"}${cliente.bairro ? ` - ${formatarNomeUpper(cliente.bairro)}` : ""}${cliente.cidade ? `, ${formatarNomeUpper(cliente.cidade)}` : ""}${cliente.estado ? `/${cliente.estado.toUpperCase()}` : ""}${cliente.cep ? `, CEP: ${aplicarMascaraCEP(cliente.cep)}` : ""}`
                  : "Não informado"}
              </p>
              <p><b>Indicado por:</b> {formatarNomeUpper(cliente.indicadoPor) || "Não informado"}</p>

              {/* BOTOES DE HISTORICOS E PRONTUARIO */}
              <div className="actions-inline" style={{ display: "flex", gap: "10px", marginTop: "15px", flexWrap: "wrap" }}>
                <button
                  type="button"
                  onClick={onAbrirHistoricoCliente}
                  className="btn-primary"
                >
                  📋 Histórico do Cliente
                </button>

                <button
                  type="button"
                  className="btn-primary"
                  onClick={onAbrirHistoricoFinanceiro}
                  style={{ backgroundColor: "rgba(28, 151, 24, 0.85)" }}
                >
                  💳 Histórico Financeiro
                </button>

                <button
                  type="button"
                  className="btn-primary"
                  onClick={onAbrirProntuarioCliente}
                  style={{ backgroundColor: "#4a5568" }}
                >
                  📁 Prontuário do Cliente
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalDetalhesCliente;